import { createSlice } from "@reduxjs/toolkit";
import { getAppointments, saveAppointments } from "./thunks";
import { message, notification } from "antd";
import dayjs from "../../utils/dayjs";

const initialState = {
  appointments: {},
  loading: true,
};

const appointmentsSlice = createSlice({
  name: "appointments",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAppointments.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAppointments.fulfilled, (state, action) => {
        const { data, month_year } = action.payload;

        state.appointments[month_year] = data || [];

        state.loading = false;
      })
      .addCase(getAppointments.rejected, (state) => {
        state.loading = false;
      })
      .addCase(saveAppointments.fulfilled, (state, action) => {
        const { data, message: successMessage, note } = action.payload;
        const key = dayjs(data?.start_time).format("MM-YYYY");
        if (!state.appointments[key]) {
          state.appointments[key] = [];
        }
        state.appointments[key].push(data);
        if (note) {
          notification.warning({
            title: "Upgrade Required",
            description: note,
          });
        }
        message.success(successMessage || "Appointment added successfully!");
      });
  },
});

export const { setKeyValue } = appointmentsSlice.actions;

export default appointmentsSlice.reducer;
